/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SendPrescriptionAliases {
  BARCODE_EXAM_CONTAINER = 'barcode-exam-container',
  BUTTON_SEND_CONTAINER = 'button-send-container',
  FIELD_PRESCRIPTION = 'field-prescription',
  INPUT_PRESCRIPTION = 'input-prescription',
  PANEL_DECK = 'panel-deck',
  PRESCRIPTION_ACTIONS_PANEL = 'prescription-actions-panel',
  PRESCRIPTION_BARCODE_PANEL = 'prescription-barcode-panel',
  SELECTED_PENDING_EXAMS_CARD = 'selected-pending-exams-card',
  SEND_EXAM_PRESCRIPTION_BUTTON_PANEL = 'send-exam-prescription-button-panel',
  SEND_EXAMS_DECK = 'send-exams-deck',
  SEND_PRESCRIPTION_BUTTON_PANEL = 'send-prescription-button-panel',
  SEND_PRESCRIPTION_LAYOUT = 'send-prescription-layout',
  SEND_PRESCRIPTION_PANEL = 'send-prescription-panel',
}
export { SendPrescriptionAliases };
